import React, { useCallback, useEffect, useState } from "react";
import useAxiosPrivate, { axiosHrPrivate } from "../../api/useAxios";
import notify from "devextreme/ui/notify";
import { usePublicEvents } from "../../contexts/public-events";
import { LoadPanel } from "devextreme-react";

function BaseFormCore(
    {
        readOnly, setReadOnly,
        formData, setFormData,
        dirty, setDirty,
        dataLoading, setDataLoading,
        formRef,
        loadId,
        setId,
        initialValues,
        toUpdateValues,
        loadUrl,
        updateUrl,
        children,
        onAfterLoadData,
        onAfterSave,
        onAfterFetch,
        setSaveEvent,
        setDirtyEvent,
        setReadOnlyEvent,
        setCancelEvent
    }
) {
   // console.log("setSaveEvent",setSaveEvent)
    const resetValues = () => {
        formRef?.current.instance.resetValues()
    }

    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)

    const loadData = () => {

        if (loadId) {
            (async function () {
                if (setDataLoading) {
                    setDataLoading(true)
                }

                await axiosPrivate.get(`${loadUrl}${loadId}`)
                    .then((response) => {
                        if (response?.status === 200) {
                            if (response.data?.data) {

                                var data = { ...response.data.data };

                                if (onAfterFetch) {
                                    (async function () {
                                        await onAfterFetch(data)
                                            .then((resData) => {
                                                //console.log("resData",resData)
                                                setFormData(resData)
                                            })
                                    })()
                                }
                                else {
                                    formData = data // setFormData ile güncelleme geç oluyor, onAfterLoadData güncel formdatayı göremiyor diye ekledim
                                    setFormData(data)
                                }

                                if (onAfterLoadData)
                                    onAfterLoadData(data)

                                setDirty(false)
                            }
                            else
                                resetValues()
                        }
                        if (setDataLoading) {
                            setDataLoading(false)
                        }

                    })
                    .catch(
                        (err) => {
                            console.log(err)
                            if (setDataLoading) {
                                setDataLoading(false)
                            }
                        }
                    )

            })()
        }
    }

    const handleSubmit = useCallback(async (e) => {        
        if (!formRef.current.instance.validate().isValid)
            return;

        if (!formData.id && initialValues) {
            formData = { ...formData, ...initialValues }
            setFormData(formData)
        }
        if (toUpdateValues) {
            formData = { ...formData, ...toUpdateValues }
            setFormData(formData)
        }

        const data = {}
        data.values = JSON.stringify(formData)
        
        if (formData.id)
            data.key = formData.id

        const axiosOptions = {
            method: formData.id ? "put" : "post",
            url: updateUrl,
            data: data
        }

        try {
            const response = await axiosPrivate(axiosOptions)

            if (response?.status === 201) {
                if (!formData.id)
                    if (response.data?.data?.id) {
                        // BU KULLANIM DA DOĞRU
                        // setFormData({
                        //     ...formData,
                        //     id: response.data.data.id
                        // })

                        setFormData((prev) => {
                            return {
                                ...prev,
                                id: response.data.data.id
                            }
                        })
                        if (setId)
                            setId(response.data.data.id)
                    }
            }

            if (response?.status === 201 || response?.status === 200) {
                notify("İşlem başarılı", "success")
                setDirty(false)
                //setReadOnly(true) // yetkiye göre ayarlaacağız

                try {
                    if (onAfterSave)
                        onAfterSave(response.data?.data);
                } catch (error) {
                    console.log("onAfterSave error.", error)
                }

            }
        } catch (error) {
            notify("Bir hata oluştu. Kayıt başarısız.", "danger")
        }

    }, [formData, setFormData])

    const handleCancel = useCallback(() => {
        setDirty(false)
        loadData()

    }, [loadId])

    useEffect(() => {

        if (loadId)
            loadData()
        else {
            resetValues()
            //setReadOnly(false)
        }

    }, [loadId])

    useEffect(() => {
        //console.log("base form use effect handleSubmit setSaveEvent",setSaveEvent)
        if (setSaveEvent)
            setSaveEvent(() => handleSubmit)

        return () => {
            if (setSaveEvent)
                setSaveEvent(undefined)
        }
    }, [handleSubmit,setSaveEvent])

    useEffect(() => {
        if (setCancelEvent && loadId)
            setCancelEvent(() => handleCancel)

        return () => {
            if (setCancelEvent)
                setCancelEvent(undefined)
        }
    }, [handleCancel, loadId])

    useEffect(() => {
        if (setDirtyEvent)
            setDirtyEvent(dirty)
    }, [dirty])

    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    )
}


function BaseFormWithBreadCrumbs(props) {

    const {
        setPublicSaveEvent,
        setPublicDirty,
        setPublicReadOnly,
        setPublicCancelEvent } = usePublicEvents(undefined)

    return <BaseFormCore
        {...props}
        setSaveEvent={setPublicSaveEvent}
        setDirtyEvent={setPublicDirty}
        setReadOnlyEvent={setPublicReadOnly}
        setCancelEvent={setPublicCancelEvent}
    />
}

export function BaseForm(props) {
    return <BaseFormCore {...props} />
}

export default BaseFormWithBreadCrumbs